import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <>
      <header />
      <main className="auth-layout">
        <Outlet />
      </main>
      <footer />
    </>
  );
};

export default AuthLayout;
